import { render, staticRenderFns } from "./SubmenuNav.vue?vue&type=template&id=7a65cdcc&scoped=true&"
import script from "./SubmenuNav.vue?vue&type=script&lang=js&"
export * from "./SubmenuNav.vue?vue&type=script&lang=js&"
import style0 from "./SubmenuNav.vue?vue&type=style&index=0&id=7a65cdcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65cdcc",
  null
  
)

export default component.exports